import { useEffect, useState, } from 'react'
import Modal from './Model'
import { useForm } from 'react-hook-form'
import Button from '../../components/utils/Button';

const PriceMappingModel = ({ title, showModal, handleCancel, showButton = false, buttonTitle, submitData, loading, formData, priceMappingData, labelClass }) => {
    const { register, handleSubmit, formState: { errors }, watch, reset, control, setValue } = useForm({
        defaultValues: formData,
    });

    useEffect(() => {
        if (priceMappingData?.length > 0) {
            priceMappingData.forEach((item, ind) => {
                setValue(`prices.${ind}.dealerPrice`, item.dealerPrice);
            });
        }
    }, [priceMappingData, setValue]);

    const planformSubmit = (data) => {
        submitData(data, priceMappingData);
    };

    return (
        <Modal
            title={title}
            showModal={showModal}
            onHide={handleCancel}
            showFooter={showButton}
            width={800}
        >
            <form onSubmit={handleSubmit(planformSubmit)}>
                <div className="form-row">
                    {priceMappingData.map((item, ind) => (
                        <div className="col-md-4 mb-4" key={ind}>
                            <label className={labelClass}>{item.networkName}</label>
                            <input type="number" step="0.01" placeholder="Enter Dealer Price" className="form-control"
                                {...register(`prices.${ind}.dealerPrice`, {
                                    min: {
                                        value: 0,
                                        message: "Price cannot be negative",
                                    },
                                })}
                            />
                            {errors?.prices?.[ind]?.dealerPrice && (<small className="text-danger"> {errors.prices[ind].dealerPrice.message} </small>)}
                        </div>
                    ))}
                </div>
                <hr />
                <div className='text-right row'>
                    <div className="col-md-12">
                        <button type="button" className="btn btn-secondary mr-2" onClick={handleCancel}>Close</button>
                        <Button title={buttonTitle} style="minWidth:80px" buttonClass="btn btn-primary" loading={loading} buttonType='submit' />
                    </div>
                </div>

            </form>
        </Modal>
    )
}

export default PriceMappingModel
